import script from "./TransactionDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionDetailView.vue?vue&type=script&setup=true&lang=js"

import "./TransactionDetailView.vue?vue&type=style&index=0&id=90f54d10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90f54d10"]])

export default __exports__